export default "__VITE_ASSET__80969538__"